exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "form[data-v-ea564132]{margin:10px 20px}table[data-v-ea564132]{border-collapse:collapse;margin-bottom:10px}th[data-v-ea564132]{text-align:left;padding-right:10px}th[data-v-ea564132],td[data-v-ea564132]{padding-bottom:5px}.loading[data-v-ea564132]{padding:30px;width:30px;height:30px}", ""]);

